// JsFromRoutes CacheKey 3e142ed4812f67900ca074b7500e970f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/contacts'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/workspace/:venue_slug/contacts'),
  new: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/contacts/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/contacts/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/contacts/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/api/workspace/:venue_slug/contacts/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/api/workspace/:venue_slug/contacts/:id'),
}
